/** Entities authenticate through an authorized signatory, not their own Civil ID. */
export interface KycCustomerIdentity {
    customerType?: string;
    commercial_register?: string;
    civilID?: string;
    other_id?: string;
}

export function isEntityKycCustomer(customer: KycCustomerIdentity): boolean {
    return customer.customerType === "company"
        || customer.customerType === "trust"
        || !!customer.commercial_register?.trim();
}

/** Only individuals identified solely by another ID require DocuSign. */
export function requiresDocusignForKyc(customer: KycCustomerIdentity): boolean {
    return !isEntityKycCustomer(customer)
        && !customer.civilID?.trim()
        && !!customer.other_id?.trim();
}
